export default {
  menu: {
    auth: '动态住宅代理',
    subaccount: '子账号管理',
    trafficRecord: '流量使用记录',
    purchaseOnline: '在线购买',
    dynamicPurchase: '动态住宅购买',
    recordQuery: '记录查询',
    flowChangeRecord: '流量变动记录',
    loginRecord: '登录记录',
    proxyCheck: '代理检测',
    personalCenter: '个人中心',
    personalSettings: '个人设置',
    logout: '退出登录',
    accountSettings: '账户设置',
    home: '首页',
    dynamicProxy: '动态住宅代理',
    helpCenter: '帮助中心',
    login: '登录',
    register: '注册',
    dashboard: '控制台',
    staticProxy: '静态住宅代理',
    staticList: '静态列表',
    staticPurchase: '原生静态购买',
    broadcastPurchase: '广播静态购买',
    customerService: '联系客服'
  },
  header: {
    logoutSuccess: '退出登录成功'
  },
  login: {
    welcomeBack: '欢迎回来',
    signInToContinue: '登录您的账户以继续',
    usernamePlaceholder: '用户名/邮箱',
    passwordPlaceholder: '密码',
    captchaPlaceholder: '验证码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码?',
    loginBtn: '登录',
    noAccount: '还没有账号？',
    registerNow: '立即注册',
    slogan: '连接全球，畅享无限可能',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    getCaptchaFailed: '获取验证码失败',
    inputUsername: '请输入用户名',
    inputPassword: '请输入密码',
    inputCaptcha: '请输入验证码'
  },
  register: {
    createAccount: '创建账号',
    subtitle: '免费注册，开启全球代理之旅',
    usernamePlaceholder: '用户名',
    passwordPlaceholder: '设置密码',
    confirmPasswordPlaceholder: '确认密码',
    registerBtn: '立即注册',
    hasAccount: '已有账号？',
    loginNow: '立即登录',
    inputUsername: '请输入用户名',
    usernameMinLength: '用户名至少3个字符',
    inputPassword: '请输入密码',
    inputConfirmPassword: '请再次输入密码',
    passwordMismatch: '两次输入密码不一致!',
    inputCaptcha: '请输入验证码',
    registerSuccess: '注册成功！',
    registerFailed: '注册失败',
    registerFailedRetry: '注册失败，请重试'
  },
  home: {
    hero: {
      title: '全球住宅IP 资源服务商',
      subtitle: '整合真实家庭住宅IP，汇聚IP资源池，不断更新IP<br />来自全球各个国家地区进行访问，助力业务全球化',
      buyNow: '立即购买',
      contactSales: '联系销售'
    },
    banner: {
      global: '遍布全球',
      globalDesc: '精准定位海外190+地区',
      safe: '安全高匿',
      safeDesc: '99.9%稳定运行时间',
      exclusive: '专享资源',
      exclusiveDesc: '10000+知名企业信赖',
      support: '即时帮助',
      supportDesc: '24/7全天候实时帮助'
    },
    stats: {
      ipPool: '全球IP池数量',
      dailyUpdate: '今日更新数量',
      successRate: '全球IP成功率',
      locations: '覆盖国家/地区'
    },
    features: {
      title: '核心优势',
      subtitle: '整合顶尖技术 构建更强体验',
      concurrency: '超高并发',
      concurrencyDesc: '独享高性能服务器，以真实住宅地址进行请求访问，保持代理正常连接，不限制并发数量。',
      resources: '优质IP资源',
      resourcesDesc: '整合真实家庭住宅IP，汇聚IP资源池，不断更新IP，来自全球各个国家地区进行访问。',
      diversity: '形式多样',
      diversityDesc: '多种代理认证模式，帮助账户灵活设置，支持账密模式和API白名单模式。',
      service: '技术服务',
      serviceDesc: '支持业务场景定制独享IP，千兆超高速带宽，出口IP可定制时效。'
    },
    product: {
      badge: '热门产品',
      title: '动态住宅代理',
      desc: '动态住宅代理网络是包含互联网服务提供商（ISP）提供的真实IP地址的一个代理网络。这些IP地址连接到全球各地国家或城市级别的物理位置。',
      pool: '住宅IP池',
      success: '连接成功率',
      coverage: '覆盖地区',
      learnMore: '了解更多详情'
    },
    useCases: {
      title: '全场景业务支持',
      desc: '满足您多样化的业务需求，助力企业高效发展',
      dataCollection: '数据采集',
      brandProtection: '品牌保护',
      marketing: '网络营销',
      seo: 'SEO监控',
      priceComparison: '价格比较',
      security: '网络安全',
      reviewMonitoring: '评论监控',
      adVerification: '广告验证'
    },
    map: {
      title: '遍布全球的资源网络',
      desc: '日更新活跃IP超9000万个，99%可用率'
    },
    footer: {
      desc: '专业的全球大数据代理服务提供商，致力于为全球用户提供优质的代理IP服务。',
      products: '产品服务',
      support: '技术支持',
      contact: '联系我们',
      copyright: 'Copyright © {year} xxxxproxy. All Rights Reserved.'
    }
  },
  staticProxy: {
    hero: {
      title: '静态住宅代理',
      subtitle: '提供纯净、稳定、独享的真实家庭宽带IP，适合长期运营的业务场景',
    },
    features: {
      title: '核心优势',
      speed: '极速网络',
      speedDesc: '高带宽低延迟，保证数据抓取和访问的极致速度。',
      stability: '超高稳定性',
      stabilityDesc: '企业级服务器基础设施，SLA 99.9% 在线率。',
      location: '精准定位',
      locationDesc: '支持国家、城市级精准定位，满足各种地域限制要求。',
      ip: '纯净独享IP',
      ipDesc: '完全独享的家庭住宅IP，极高的信任度和匿名性。',
      pure: '安全可靠',
      pureDesc: '白名单和账密双重认证方式，保障您的数据安全。',
      support: '7x24小时技术支持',
      supportDesc: '专业的技术团队随时待命，为您解决任何使用问题。'
    },
    pricing: {
      title: '价格方案',
      ip: '个IP',
      unlimitedTraffic: '不限流量',
      exclusiveIP: '独享IP资源',
    },
    useCases: {
      title: '适用场景',
      socialMedia: {
        title: '社交媒体营销',
        desc: '管理多个社交媒体账号，避免关联封号，提升品牌曝光率。'
      },
      eCommerce: {
        title: '跨境电商',
        desc: '稳定访问全球电商平台，抢购限量商品，进行市场分析。'
      },
      marketResearch: {
        title: '市场调研与数据抓取',
        desc: '持续稳定地抓取竞争对手数据、商品价格及行业动态，获取真实的市场情报。'
      },
      seo: {
        title: 'SEO 监控与优化',
        desc: '模拟不同地区的真实用户搜索行为，监控关键词排名，优化搜索引擎策略。'
      },
      adVerification: {
        title: '广告验证与投放',
        desc: '验证全球各地的广告展示效果，防止广告欺诈，确保营销预算的有效使用。'
      },
      brandProtection: {
        title: '品牌与版权保护',
        desc: '匿名监控侵权行为，保护知识产权，防止未经授权的内容分发与滥用。'
      }
    },
    advantages: {
      title: '为什么选择我们的静态住宅代理？',
      items: [
        {
          title: '100% 真实家庭宽带 IP',
          desc: '我们的静态住宅代理 IP 全部来自真实的家庭宽带用户，非机房 IP。这意味着您的访问请求会被目标网站视为普通用户的正常访问，极大降低了被识别为机器人和被封锁的概率。'
        },
        {
          title: 'IP 长期独享，稳定不掉线',
          desc: '与动态代理不同，静态住宅代理提供固定的 IP 地址，购买期内由您完全独享。这非常适合需要长期保持固定 IP 登录状态的业务场景，如社交媒体账号养号、电商店铺运营等。'
        },
        {
          title: '覆盖全球核心地区',
          desc: '我们在全球多个核心国家和城市部署了静态住宅代理节点，支持精准的地理位置选择，帮助您轻松突破地域限制，访问特定国家或地区的专属内容和服务。'
        }
      ]
    }
  },
  purchase: {
    accountInfo: '账户信息',
    currentPlan: '您当前计划',
    noPlan: '无',
    perGigabytePrice: '您的每千兆字节价格',
    whatTypeBroadband: '您需要什么类型的宽带？',
    dynamicResidence: '动态住宅',
    needOverGB: '需要超过几GB的带宽？',
    buyPackage: '以更优惠的每GB价格购买我们的套餐之一',
    selectPackage: '选择套餐',
    discountPrice: '折扣价',
    confirm: '确认',
    cancel: '取消',
    loginWarning: '请重新登录！',
    pleaseSelectPackage: '请选择套餐'
  },
  dynamicProxy: {
    hero: {
      title: '动态住宅代理',
      subtitle: '拥有全球9000万+真实住宅IP资源，覆盖195个国家/地区<br>高匿名、高并发、极速响应，助力业务无忧出海',
      buyNow: '立即购买',
      contactSales: '联系销售'
    },
    features: {
      title: '为什么选择我们的动态住宅代理？',
      successRate: '99.9% 成功率',
      successRateDesc: '我们的IP池经过严格筛选和实时监控，确保极高的连接成功率和稳定性。',
      concurrency: '无限并发会话',
      concurrencyDesc: '支持海量并发请求，满足大规模数据采集和业务扩展需求，无速度限制。',
      location: '精准定位',
      locationDesc: '支持国家、城市、州/省级别的精准定位，满足精细化业务场景需求。',
      rotation: '自动轮换IP',
      rotationDesc: '支持按请求轮换或设置粘性会话时长，灵活应对各种反爬策略。',
      pure: '纯净IP资源',
      pureDesc: '来自真实家庭宽带用户的IP，高匿名性，极低被封锁风险。',
      speed: '极速响应',
      speedDesc: '全球分布式节点，智能路由选择，确保最低延迟的访问体验。'
    },
    pricing: {
      title: '灵活的价格方案',
      starter: '入门版',
      pro: '专业版',
      enterprise: '企业版',
      startNow: '立即开始',
      traffic: '流量',
      unlimitedConcurrency: '不限并发',
      countryLocation: '国家级定位',
      cityLocation: '城市级定位',
      fullLocation: '全功能定位',
      authMode: 'API/账密认证',
      validity30: '30天有效期',
      validity90: '90天有效期',
      validityPermanent: '永久有效',
      exclusiveSupport: '专属客服支持'
    }
  },
  help: {
    hero: {
      title: '帮助中心',
      subtitle: '搜索文档、教程和常见问题解答'
    },
    tabs: {
      intro: '入门',
      pricing: '价格',
      account: '账户',
      troubleshoot: '故障'
    },
    contact: {
      title: '还需要帮助？',
      desc: '如果您没有找到问题的答案，请联系我们的支持团队。',
      contactUs: '联系我们'
    },
    faq: {
      q1: '使用IP代理为什么没有网络？',
      a1: '海外IP需要在境外环境上使用，如已经在境外环境，请检查服务器的IP地址是否添加到白名单',
      q2: '什么是IP白名单？',
      a2: 'IP白名单是xxxxproxy代理的验证机制，在使用代理服务时，需要先将使用代理的服务器IP添加到白名单，有以下两种形式：<br>（1）本机服务器使用代理：生成链接后，系统将提示添加本机服务器IP至白名单，确认添加后即可使用代理服务<br>（2）其他服务器使用代理：在xxxxproxy账户后台添加IP白名单，支持添加多个IP白名单',
      q3: 'IP支持哪些协议？',
      a3: '支持HTTP、HTTPS、SOCKS5三种协议<br>官网获取的是HTTP、HTTPS，协议互通，在代理时设置请求协议直接代理即可；如果有获取不到的情况，可以联系客服进行协助处理',
      q4: 'IP使用有哪些限制？',
      a4: 'IP没有请求和并发限制，api链接提取频率是1秒1次，IP提取单次最多可达900个。有其他额外需求联系客服协助处理',
      q5: '手机可以设置代理吗？',
      a5: '手机同样需要境外环境，打开手机的WLAN设置，选择连接的无线网络；点击无线网络设置，代理设置点击手动；手动输入在xxxxproxy获取的IP和端口',
      q6: '获取的代理IP实际不是最终的出口IP',
      a6: 'IP为隧道转发，出口是真实IP，IP段一致，端口不同，每一个端口对应一个ip',
      q7: '如何检查本地网络？',
      a7: '您可以打开cmd输入curl ipinfo.io查看当前的IP地址',
      q8: 'xxxxproxy推广计划能永久奖励吗？',
      a8: '区别于其他的推广计划，xxxxproxy不会限制您的奖励周期，永久收益！<br>（1）推荐新用户免费试用xxxxproxy， 获3元/位现金奖励！<br>（2）推荐新用户购买获30%奖励，高至5000元！<br>（3）若用户复购，您可享受每笔订单5%奖励，每笔最高1000元， 立刻赚取奖励！',
      q9: 'xxxxproxy代理覆盖哪些国家地区？',
      a9: '目前覆盖了包括美国、英国、加拿大、印度、韩国等热门国家在内的220多个国家和地区，<br>为用户提供超9000万IP数量，点击 此处了解更多国家及IP数量。',
      q10: 'xxxxproxy提供哪些代理方案？',
      a10: 'xxxxproxy目前为您提供以下6种解决方案：<br>动态住宅、 静态住宅、 独享数据中心、 动态长效ISP、 动态数据中心、 移动代理。<br>另外，我们还提供“ 网页解锁工具”，实现网页爬虫率大于99.99%，一键发送请求，即可轻松获得最准确的数据。',
      q11: 'xxxxproxy代理可运用于哪些业务场景？',
      a11: 'xxxxproxy代理可运用于以下业务场景：<br>品牌保护、广告验证、网站测试、股市数据、市场调查、竞争对手情报、抓取索引、邮件保护、<br>SEO监控优化、旅游信息聚合等，您的业务具体适用哪种代理，您可咨询 客户经理 为您解答。',
      q12: '如何免费测试？',
      a12: '新用户注册后进行实名认证，添加白名单按照使用流程即可免费测试动态流量，个人认证送30元额度，免费试用230M流量，技术认证送80元额度，免费试用600M流量，企业认证送150元额度，免费试用1G流量',
      q13: 'IP是怎么收费的？',
      a13: '动态IP按照流量进行收费，流量计算方式为：上行+下行，计算上传的流量加下载的流量总和；数据中心IP、静态住宅按照IP个数计费',
      q14: '生成的API链接没有账号标识，如何计费',
      a14: '通过白名单判定，只有服务器ip在白名单列表里才能获取和使用ip，否则是提取不了ip的，一个白名单IP只能在一个账号里使用，按照白名单所在账号扣除流量费用',
      q15: '支持开具发票吗？',
      a15: '联系客服可以开具电子发票，纸质发票（专票）需要签订购买合同，电子发票没有金额限制，开票顺序是从大金额到小金额，金额小的开具有时效性，可能出现次月开具的情况',
      q16: '免费赠送流量用完后，会自动扣费吗？',
      a16: '不会自动扣费，免费赠送的流量用完后，将无法继续获取代理，只有在购买套餐或充值后，按照价格计费使用。',
      q17: '额度套餐有时效吗？额度会清空吗？',
      a17: '额度套餐是通过账户充值获得专属额度，账户额度没有时效限制<br>30天时效是首次充值时，首次使用代理的计费单价时效，30天内按照套餐优惠单价扣费 超过30天，按照原价计费：<br>动态住宅：130￥/GB<br>动态数据中心：20￥/GB<br>动态长效ISP：130￥/GB',
      q18: '额度套餐充值后可以使用哪些套餐类型？',
      a18: '账户额度有两种使用方式：<br>1、动态住宅/动态数据中心/动态长效ISP/超级代理，根据代理使用量扣费。<br>2、静态住宅/独享数据中心，支持使用账户额度购买对应套餐。',
      q19: '如果IP过期了，续费后可以继续使用同一个IP吗？',
      a19: 'IP过期后无法续费，请注意过期时间并在IP到期前续费',
      q20: '静态住宅IP有流量限制吗？',
      a20: '按照数量计费，没有流量限制',
      q21: '独享数据中心和动态数据中心有什么区别？',
      a21: '两种IP都来自IDC机房，标记为机房IP<br>动态数据中心按照流量计费，自定义1-30min IP时效，高效轮转<br>独享数据中心按照IP数量计费，是个人专享使用的长效IP地址，可选择周/月/季或定制IP时效',
      q22: '额度套餐与产品套餐有什么区别？',
      a22: '产品套餐：根据业务需要选择动态住宅、静态住宅、数据中心、动态ISP或移动代理，套餐时效<br>包括周套餐、月套餐、季度套餐或定制时效，套餐到期将清空流量。<br>额度套餐：根据需要选择充值额度，充值的额度可以使用xxxxproxy所有代理类型。<br>动态住宅/动态数据中心/动态长效ISP/超级代理，根据代理使用量扣费，随用随扣；<br>静态住宅/独享数据中心，支持使用账户额度购买对应套餐。',
      q23: '未使用完的流量能否转存到下个月？',
      a23: '若您购买了 动态住宅包月套餐，流量未在1个月内使用完，则不可转存到下个月，<br>您可在购买前考虑好用量，选择适合您的月度套餐；若您购买了 额度套餐，<br>则按照使用量扣费，流量使用无时效问题，随用随扣。',
      q24: 'xxxxproxy是否支持城市级定位？',
      a24: 'xxxxproxy支持多个国家的城市精准定位，您可从指定的国家城市访问目标网站，详情可咨询 客户经理。',
      q25: 'IP限制使用终端设备数量吗',
      a25: '动态按照流量计费，对并发和同时连接数没有限制。',
      q26: '账密认证如何使用？',
      a26: '账密认证是通过主账户创建认证账户进行流量分配。用户可以通过创建多个“认证账户”，给每个认证账户设置流量额度，根据业务需求灵活使用。具体操作参照“账密认证使用教程”。',
      q27: '服务器IP被多个账号加入白名单会怎样？',
      a27: '例如A、B两个帐号同时使用一个服务器，服务器IP保存在A账户，则扣除A账户流量，如在B账户，则扣除B账户流量；如服务器IP已保存在A账户，B账户再次添加，则会顶到A账户服务器IP留存，使用流量则扣除B账户',
      q28: '链接生成的IP可以一直使用吗？',
      a28: 'api代理模式，会不定时升级维护服务器，IP和端口也会改变，不建议长时间一直用一个IP段，可以每几天获取换一次。如果是账密代理模式可以一直用。',
      q29: '账户有流量，生成API链接提示额度不足',
      a29: '请在xxxxproxy账户后台检查是否添加白名单，添加白名单后再次获取API链接，若已添加，删掉白名单重新添加，再次获取API链接',
      q30: '如何通过程序判断代理是否失效',
      a30: '官网后台可以设置IP时效，动态最长可以设置30分钟，IP是隧道转发的，失效后会自动切换'
    }
  },
  dashboard: {
    auth: {
      trafficOverview: '流量概览',
      remainingTraffic: '剩余流量',
      remaining: '剩余',
      total: '总计',
      credentials: '认证凭证',
      resetPassword: '重置密码',
      host: '主机 Host',
      port: '端口 Port',
      user: '用户名 User',
      pass: '密码 Pass',
      generator: '代理生成器',
      generatorSubtitle: '配置并提取您的动态住宅代理',
      location: '地理位置 Location',
      country: '国家 Country',
      region: '地区 Region',
      city: '城市 City',
      any: '不限',
      settings: '配置参数 Settings',
      subAccount: '子账户',
      quantity: '提取数量',
      duration: '时效 (分钟)',
      format: '格式',
      select: '请选择',
      rotationMode: '轮换模式',
      sticky: '定期更换',
      rotating: '一次一换',
      generate: '立即生成代理',
      copyAll: '复制全部',
      download: '下载文件',
      copySuccess: '已成功复制到粘贴板',
      copyFail: '该浏览器不支持复制',
      modifySuccess: '修改成功',
      relogin: '请重新登录！'
    },
    subaccount: {
      overview: '资源概览 Overview',
      masterAvailable: '主账号可用',
      sonTotal: '子账号总额',
      sonRemaining: '子账号剩余',
      actions: '快速操作 Actions',
      create: '新建子账号',
      searchPlaceholder: '搜索用户名...',
      query: '查询',
      listTitle: '账号列表 Account List',
      refresh: '刷新',
      totalItems: '共 {total} 条',
      columns: {
        username: '用户名',
        totalFlow: '总流量',
        usedFlow: '已用流量',
        host: '主机地址',
        port: '端口',
        password: '访问密码',
        createTime: '创建时间',
        remark: '备注信息',
        action: '操作'
      },
      topUp: '充值流量',
      deduct: '扣除流量',
      editRemark: '修改备注',
      delete: '删除账号',
      confirmDelete: '确认删除',
      cancel: '取消',
      confirmDeleteMsg: '确定要删除账号 {username}?',
      createModal: {
        title: '创建子账号',
        name: '账号名称',
        namePlaceholder: '设置用户名',
        password: '设置密码',
        passwordPlaceholder: '设置密码',
        flow: '分配流量',
        flowPlaceholder: '输入流量大小'
      },
      topUpModal: {
        title: '增加流量',
        label: '增加流量',
        placeholder: '输入增加额度'
      },
      deductModal: {
        title: '扣除流量',
        label: '扣除流量',
        placeholder: '输入扣除额度'
      },
      editModal: {
        title: '更新备注',
        label: '备注内容',
        placeholder: '输入新的备注...'
      },
      msg: {
        fetchFail: '获取子账号列表失败',
        listLoadFail: '列表加载失败',
        incomplete: '请填写完整信息',
        createSuccess: '创建成功',
        addFail: '添加失败',
        createFail: '创建失败',
        updateSuccess: '更新成功',
        modifyFail: '修改失败',
        updateFail: '更新失败',
        invalidNum: '请输入有效的数值',
        opSuccess: '操作成功',
        opFail: '操作失败',
        topUpFail: '充值失败',
        deductFail: '扣除失败',
        deleteFail: '删除失败',
        dataFail: '数据获取失败'
      }
    },
    traffic: {
      allAccounts: '全部账户',
      overview: '资源概览 Overview',
      totalConsumption: '总流量消耗',
      peakUsage: '峰值用量',
      control: '控制面板 Control',
      switchView: '切换视角',
      selectSubAccount: '选择子账号',
      queryData: '查询数据',
      trendAnalysis: '流量趋势分析',
      refreshData: '刷新数据',
      chartTooltip: '流量消耗'
    }
  },
  countries: {
    us: '美国',
    br: '巴西',
    de: '德国',
    fr: '法国',
    in: '印度',
    ca: '加拿大',
    gb: '英国',
    es: '西班牙'
  },
  record: {
    flowChange: {
      title: '流量变动记录',
      rechargeTime: '充值时间',
      beforeFlow: '充值前流量',
      changeFlow: '充值流量',
      afterFlow: '充值后流量'
    },
    login: {
      title: '登录记录',
      username: '用户名',
      loginTime: '登录时间',
      ip: 'IP地址',
      os: '系统',
      browser: '浏览器'
    }
  },
  check: {
    title: '代理检测工具',
    desc: '快速验证代理服务器的连通性、匿名度及出口IP地理位置信息',
    config: '检测配置',
    proxyType: '代理类型',
    queryChannel: '查询渠道',
    proxyList: '代理列表',
    placeholder: '请输入代理信息，格式：\nIP:端口\nIP:端口:账号:密码',
    tip: '支持批量粘贴，最多20个',
    startCheck: '开始检测',
    checking: '正在检测...',
    guide: '支持格式',
    hasPassword: '有密码:',
    example: '示例:',
    result: '检测结果',
    total: '共 {total} 条',
    clear: '清空',
    empty: '请在左侧添加代理信息进行检测',
    columns: {
      info: '代理信息',
      type: '类型',
      exportIp: '出口IP信息',
      status: '状态'
    },
    status: {
      unchecked: '未检查',
      checking: '正在检查',
      available: '可用',
      unavailable: '不可用',
      failed: '检查失败'
    },
    msg: {
      inputFirst: '请先输入代理信息'
    }
  },
  static: {
    selectCountry: '请选择国家',
    enterIP: '请输入IP',
    remark: '备注',
    search: '搜索',
    reset: '重置',
    proxyFormat: '代理链接格式',
    proxyType: '代理类型',
    broadcast: '广播',
    native: '原生',
    batchExport: '批量导出',
    batchRenewal: '批量续费',
    batchChangeAccount: '批量修改账密',
    renewal: '续费',
    export: '导出',
    changeAccount: '修改账密',
    purchaseDuration: '购买时长',
    thirtyDays: '30天',
    enterRemark: '请输入备注',
    username: '用户名',
    enterUsername: '请输入用户名',
    proxyPassword: '代理密码',
    enterPassword: '请输入密码',
    connectionAddress: '连接地址',
    port: '端口号',
    creationTime: '创建时间',
    expirationTime: '到期时间',
    ipLocation: 'IP归属地',
    operation: '操作',
    total: '共 {total} 条',
    nativeStaticPurchase: '原生静态代理购买',
    broadcastStaticPurchase: '广播静态代理购买',
    pleaseFillInfo: '请填写以下信息进行代理购买',
    businessType: '业务类型',
    businessTypeNote: '购买前请先确认您的业务类型，避免购买后无法使用的情况',
    country: '国家',
    pleaseSelectCountry: '请选择国家',
    city: '城市',
    pleaseSelectCity: '请选择城市',
    inventory: '库存',
    protocol: '协议',
    http: 'Http',
    socks5: 'Socks5',
    protocolNote: '同时支持Http、Https、Socks5协议，保持默认即可',
    durationNote: '有效时长，到期续费即可',
    purchaseQuantity: '购买数量',
    paymentAmount: '支付金额',
    integral: '积分',
    availableIntegral: '可用积分',
    rechargeIntegral: '充值积分',
    giftIntegral: '赠送积分',
    prioritizeRecharge: '优先使用充值积分',
    pay: '支付',
    confirmOrder: '确认订单',
    confirmPurchase: '确定要购买当前套餐吗',
    userId: '用户ID',
    confirmRenewal: '是否确认续费？',
    paySuccess: '支付成功',
    createFail: '创建静态套餐失败,请联系管理员~',
    networkError: '网络请求异常，请稍后重试',
    copySuccess: '已成功复制到粘贴板',
    copyFail: '该浏览器不支持复制',
    modifySuccess: '修改成功',
    relogin: '请重新登录！',
    pleaseSelectBusinessType: '请选择需要的业务类型',
    cityRequired: '城市必填',
    countryRequired: '国家必填',
    protocolRequired: '请选择协议',
    quantityRequired: '请选择购买数量',
    dontRepeatSubmit: '请勿重复提交'
  },
  user: {
    security: {
      title: '账户安全',
      subtitle: '更新您的登录密码以保护您的账户资产',
      changePassword: '修改登录密码',
      currentPassword: '当前密码',
      currentPasswordPlaceholder: '请输入当前使用的密码',
      setNewPassword: '设置新密码',
      newPassword: '新密码',
      newPasswordPlaceholder: '设置新的登录密码',
      confirmPassword: '确认新密码',
      confirmPasswordPlaceholder: '再次输入以确认',
      confirmChange: '确认修改密码',
      processing: '处理中...',
      resetForm: '重置表单',
      tipsTitle: '安全建议',
      tip1: '建议使用 8 位以上包含字母和数字的组合',
      tip2: '不要使用在其他网站上使用过的密码',
      tip3: '定期更换密码可以有效降低被盗风险',
      helpTitle: '遇到困难?',
      helpDesc: '如果您忘记了旧密码或遇到其他问题，请联系我们的客服团队。',
      contact: '联系客服',
      msg: {
        incomplete: '请填写完整信息',
        mismatch: '两次输入的密码不一致',
        length: '密码长度至少8位',
        success: '密码修改成功，请重新登录',
        fail: '密码修改失败',
        error: '系统错误，请稍后重试'
      }
    }
  }
};
